import { CommonModule } from '@angular/common'
import { Component, Input, OnDestroy, OnInit } from '@angular/core'
import { DynamicTextComponent } from '../dynamic-text/dynamic-text.component'
import { AppNameWidget } from 'htv-lib'
import { PageService } from '../../services/page.service'
import { LocalApp } from '../../interfaces/local-app'
import { Subscription } from 'rxjs'
import { PAGE_KEY } from '../../constants/page.constants'

@Component({
  selector: 'app-app-name',
  standalone: true,
  imports: [CommonModule, DynamicTextComponent],
  templateUrl: './app-name.component.html',
  styleUrls: [],
})
export class AppNameComponent implements OnInit, OnDestroy {
  subscriptions = new Subscription()
  @Input() config!: AppNameWidget

  text = ''

  constructor(private pageService: PageService) {
    // do nothing
  }

  ngOnInit(): void {
    this.subscriptions.add(
      this.pageService.getSubject(PAGE_KEY.SELECTED_APP)?.subscribe((app: LocalApp) => {
        if (app) {
          this.text = app.smartApp.name[0].value
        } else {
          this.text = ''
        }
      })
    )
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe()
  }
}
